// dev用(開発環境)
const config = {
    api: {
        base: "https://cms.interactive.5g.pass.auone.jp/prd",
    },
    aws: {
        region: "ap-northeast-1",
        cognito: {
            UserPoolId: "ap-northeast-1_Uf1sV8dE2",
            ClientId: "3vvo8h4vnnf6bn4mg64b81ncle",
            IdentityPoolId: "ap-northeast-1:65108921-5bd9-4eda-8e8d-29d0eb07a058",
        },
        s3: {
            getbucket: "https://cms.interactive.5g.pass.auone.jp",
            bucket: "interactive-resources-prd-uploadbucket-7qsxaj2iabv5",
        }
    },
    pageCount: 30,
    environment: "prd",
};

export default config;


// WEBPACK FOOTER //
// ./src/config/app.js